<script lang="ts">
	import ActivitiesList from './ActivitiesList.svelte';
	import { atLeastCollaborator } from '$lib/utils/roles';
	import { getHubStores } from '$lib/stores/hubStores';
	import AdminPlaceholder from './placeholder/AdminPlaceholder.svelte';
	import NoActivities from './NoActivities.svelte';
	import { onMount } from 'svelte';
	import Spinner from '$lib/components/Spinner/Spinner.svelte';
	import Wrapper from '$lib/components/Post/Tile/Wrapper.svelte';

	const { hub, restApi, activities } = getHubStores();

	let isLoading = true;
	onMount(async () => {
		if ($hub.type === 'sparq3member' && $hub.user_context.member_id) {
			let resp = await restApi.fetchActivities($hub.id);
			if (resp.data) {
				$activities = resp.data;
			}
		}
		isLoading = false;
	});
</script>

<Wrapper>
	<div>
		{#if isLoading}
			<Spinner />
		{:else if atLeastCollaborator($hub.user_context) && !$hub.user_context.member_id}
			<AdminPlaceholder />
		{:else if $activities?.length > 0}
			<ActivitiesList />
		{:else}
			<NoActivities />
		{/if}
	</div>
</Wrapper>

<style>
	div {
		display: flex;
		flex-direction: column;
		block-size: 100%;
		min-block-size: 522px; /* 81 x 5 + 63 + 54  Not sure why, taken from bluesuade */
		inline-size: 100%;
	}
</style>
